import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["prefixCls", "separator", "children", "overlay", "dropdownProps"];
import DownOutlined from "@ant-design/icons/DownOutlined";
import * as React from "react";
import { ConfigContext } from "../ConfigProvider";
import Dropdown from "../Dropdown/Dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var customizePrefixCls = _ref.prefixCls,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? "/" : _ref$separator,
    children = _ref.children,
    overlay = _ref.overlay,
    dropdownProps = _ref.dropdownProps,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("breadcrumb", customizePrefixCls);
  /** If overlay is have Wrap a Dropdown */
  var renderBreadcrumbNode = function renderBreadcrumbNode(breadcrumbItem) {
    if (overlay) {
      return /*#__PURE__*/_jsx(Dropdown, _objectSpread(_objectSpread({
        overlay: overlay,
        placement: "bottom"
      }, dropdownProps), {}, {
        children: /*#__PURE__*/_jsxs("span", {
          className: "".concat(prefixCls, "-overlay-link"),
          children: [breadcrumbItem, /*#__PURE__*/_jsx(DownOutlined, {})]
        })
      }));
    }
    return breadcrumbItem;
  };
  var link;
  if ("href" in restProps) {
    link = /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      className: "".concat(prefixCls, "-link")
    }, restProps), {}, {
      children: children
    }));
  } else {
    link = /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
      className: "".concat(prefixCls, "-link")
    }, restProps), {}, {
      children: children
    }));
  }

  // wrap to dropDown
  link = renderBreadcrumbNode(link);
  if (children) {
    return /*#__PURE__*/_jsxs("li", {
      children: [link, separator && /*#__PURE__*/_jsx("span", {
        className: "".concat(prefixCls, "-separator"),
        children: separator
      })]
    });
  }
  return null;
};
BreadcrumbItem.__PI_BREADCRUMB_ITEM = true;
export default BreadcrumbItem;